import { useState, useEffect } from "react";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import AuthShell from "@/components/AuthShell";
import { toast } from "sonner";

export default function Login() {
  const { loginWithPassword, user } = useAuth();
  const nav = useNavigate();
  const [sp] = useSearchParams();
  const next = sp.get("next");
  const [email, setEmail] = useState(new URLSearchParams(window.location.search).get("email") || "");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (user) nav(next || (user.onboarding_complete ? "/dashboard" : "/onboarding")); }, [user, nav, next]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await loginWithPassword(email, password);
      nav(next || (u.onboarding_complete ? "/dashboard" : "/onboarding"));
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Welcome back" subtitle="Sign in to your GetCerty account"
      footer={<>New to GetCerty? <Link to="/signup" className="text-emerald-brand font-semibold">Create an account</Link></>}>
      <form onSubmit={submit} className="space-y-3">
        <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email address"
          className="w-full min-h-[48px] px-4 rounded-xl border border-input bg-card focus:ring-2 focus:ring-emerald-500 focus:outline-none" />
        <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password"
          className="w-full min-h-[48px] px-4 rounded-xl border border-input bg-card focus:ring-2 focus:ring-emerald-500 focus:outline-none" />
        <button data-testid="login-submit" disabled={loading} className="w-full min-h-[48px] rounded-xl bg-navy hover:bg-navy-700 text-white font-semibold transition-colors disabled:opacity-60">
          {loading ? "Signing in…" : "Sign in"}
        </button>
      </form>
      <p className="mt-3 text-xs text-muted-foreground text-center">Demo: demo@certy.app / Demo1234!</p>
    </AuthShell>
  );
}
